import client from "../libs/HttpClient";

class ContactServices {
  static contactList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/contacts?page=${page_no}`, request);
  }
  static updateContact(request) {
    return client.post(`/review-contact`, request, {});
  }
  static viewContact(params) {
    return client.get(`get-contact`, { params });
  }
  static deleteContact(params) {
    return client.delete(`delete-contact`, { params });
  }
}

export { ContactServices };
